'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var callAll = function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};

var noop = function noop() {};

function Toggle(_ref) {
  var _ref$defaultOn = _ref.defaultOn,
      defaultOn = _ref$defaultOn === void 0 ? false : _ref$defaultOn,
      controlledOn = _ref.on,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? noop : _ref$onToggle,
      children = _ref.children;

  var isOnControlled = function isOnControlled() {
    return controlledOn !== undefined;
  };

  var _useState = React.useState(function () {
    if (isOnControlled()) {
      return controlledOn;
    }

    return defaultOn;
  }),
      on = _useState[0],
      _setOn = _useState[1];

  var getOn = function getOn() {
    if (isOnControlled()) {
      return controlledOn;
    }

    return on;
  };

  var toggle = function toggle() {
    var newOn = !getOn();

    _setOn(newOn);

    onToggle(newOn, getTogglerStateAndHelpers());
  };

  var getTogglerProps = function getTogglerProps(props) {
    if (props === void 0) {
      props = {};
    }

    return _objectSpread({
      'aria-expanded': Boolean(getOn()),
      tabIndex: 0
    }, props, {
      onClick: callAll(props.onClick, toggle),
      onKeyUp: callAll(props.onKeyUp, function (event) {
        if (toggleKeys.indexOf(event.key) > -1) {
          toggle();
        }
      })
    });
  };

  var toggleKeys = ['Enter', ' ']; // This matches <button> behavior

  var getInputTogglerProps = function getInputTogglerProps(props) {
    if (props === void 0) {
      props = {};
    }

    return getTogglerProps(_objectSpread({}, props, {
      onKeyUp: callAll(props.onKeyUp, function (event) {
        if (event.key === 'Enter') {
          // <input> already respond to Enter
          toggle();
        }
      })
    }));
  };

  var getElementTogglerProps = function getElementTogglerProps(props) {
    if (props === void 0) {
      props = {};
    }

    return getTogglerProps(_objectSpread({}, props, {
      onKeyUp: callAll(props.onKeyUp, function (event) {
        if (toggleKeys.indexOf(event.key) > -1) {
          toggle();
        }
      })
    }));
  };

  var getTogglerStateAndHelpers = function getTogglerStateAndHelpers() {
    return {
      on: getOn(),
      getTogglerProps: getTogglerProps,
      getInputTogglerProps: getInputTogglerProps,
      getElementTogglerProps: getElementTogglerProps,
      setOn: function setOn() {
        return _setOn(true);
      },
      setOff: function setOff() {
        return _setOn(false);
      },
      toggle: toggle
    };
  };

  return children(getTogglerStateAndHelpers());
}

exports["default"] = Toggle;
